import React from "react";

const CAREER_START_YEAR = 2021;

export default function AboutMe() {
  const yearsOfExperience = new Date().getFullYear() - CAREER_START_YEAR;

  const stats = [
    { value: `${yearsOfExperience}+`, label: "Years of Experience" },
    { value: "5", label: "Companies" },
    { value: "2", label: "Countries Worked With" },
  ];

  return (
    <section id="about-me" className="py-6">
      <div className="mt-12 mb-6 about-bg rounded-xl px-6 md:px-12 py-8">
        <h3 className="font-bold text-3xl">
          About <span className="text-teal-500">Me</span>
        </h3>
        <p className="mt-8 gray-font leading-relaxed">
          Energetic and flexible website/application developer with over{" "}
          {yearsOfExperience} years of experience participating in the full
          software development life cycle from planning to launch. A good
          timekeeper, always willing to keep learning and training to gain
          further useful skills and qualifications both in frontend or backend.
          Working with people from diverse backgrounds has provided me with a
          deep understanding and awareness of differences in both individuals
          and organizations.
        </p>

        <div className="grid grid-cols-3 gap-4 mt-10 pt-8 border-t border-gray-700/60">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center sm:text-left">
              <p className="text-2xl md:text-4xl font-bold text-teal-500">
                {stat.value}
              </p>
              <p className="text-xs sm:text-sm gray-font mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
